import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';

@Component({
  selector: 'nps',
  templateUrl: './nps.component.html',
  styleUrls: ['./nps.component.scss'],
})
export class NpsComponent implements OnInit {



  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit() {

   // this.secondFormGroup = this._formBuilder.group({
   //   secondCtrl: ['', Validators.required]
   // });
  }



}
